export default "__VITE_ASSET__E$nH0R$l__"